import styled from 'styled-components';

import { Dropdown as SemanticDropdown } from 'semantic-ui-react';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Dropdown = styled(SemanticDropdown)`
  &.ui.selection.dropdown {
    margin-top: 9px;

    @media(max-width: 768px) {
      width: 80%;
    }

    @media all and (max-width: 1000px) and (min-width: 768px) {
      min-width: 0;
    }
  }
`;

export const ContainerDropdown = styled.div`
  display: flex;
  flex-direction: column;

  @media(min-width: 1000px) {
    align-items: center;
  }
`;

export const Text = styled(TextLayoutComponent)`
  width: fit-content;
`;

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 800px;
  justify-content: space-between;
  align-items: center;
`;
